const contracts = [
  {
    title: 'DLA HEPP Material Handling Equipment',
    custom: 'Defense Logistics Agency',
    number: 'SPE8EC-26-D-0002',
    date: '10/28/2025 - 10/27/2030',
    max: '$433,000,000.00',
  },
  {
    title: 'Naval Special Warfare ECOTS BPA',
    custom: 'Naval Special Warfare Command',
    number: 'H9224022A0014',
    date: '09/12/2022 - 09/08/2027',
    max: '$6,499,999.00',
  },
  {
    title: '2022 Light Vehicles to Include Sedans, Light Trucks, and SUVS',
    custom: 'General Services Administration',
    number: '47QMCA22D000T',
    date: '11/08/2021 - 11/07/2026',
    max: '$2,726,076,042.00',
  },
  {
    title: '2021 Light Vehicles to Include Sedans, Light Trucks, and SUVs',
    custom: 'General Services Administration',
    number: '47QMCA20D004E',
    date: '10/01/2020 - 01/31/2022',
    max: '$241,497,546.00',
  },
  {
    title: 'Bullet-Resisting Cubicle Panels',
    custom: 'Army Corps of Engineers',
    number: 'W9128F17D0058',
    date: '09/11/2017 - 09/10/2022',
    max: '$49,900,000.00',
  },
  {
    title: 'Protective COVID-19 Shielding',
    custom: 'Transportation Security Administration',
    number: '70T05020D9DAP4088',
    date: '09/04/2021 - 09/04/2025',
    max: '$40,000,000.00',
  },
  {
    title:
      'Accessories, Tool Sets, Test Sets, and Training for Image Intensified Night Vision Devices',
    custom: 'Army Contracting Command (FMS)',
    number: 'W91CRB-21-D-5002',
    date: '11/27/2020 - 11/27/2025',
    max: '$6,900,000.00',
  },
  {
    title: 'Organizational Clothing and Individual Equipment (OCIE)',
    custom: 'Army Contracting Command (FMS)',
    number: 'W91CRB21A0005',
    date: '02/25/2021 - 02/25/2026',
    max: '$28,000,000.00',
  },
  {
    title: 'Special Warfare Procurement Multiple-Award Contract (SW-MAC)',
    custom: 'Air Force Material Command',
    number: 'FA8629-20-D-5060',
    date: '08/31/2020 - 08/31/2025',
    max: '$950,000,000.00',
  },
  {
    title: 'Stab-Resistant Vests',
    custom: 'Federal Bureau of Prisons',
    number: '15BNAS20DRCA00013',
    date: '04/27/2020 - 04/26/2022',
    max: '$4,894,200.00',
  },
  {
    title: 'Try Decide Buy (TDB)',
    custom: 'Air Force Life Cycle Management Center',
    number: 'FA8606-19-D-0037',
    date: '08/12/2019 - 08/07/2029',
    max: '$950,000,000.00',
  },
  {
    title: 'Fort Leonard Wood Personal Protective Equipment',
    custom: 'MICC - Fort Leonard Wood',
    number: 'W911S718D0009',
    date: '05/17/2018 - 05/17/2023',
    max: '$301,495.00',
  },
  {
    title: 'GSA Multiple Award Schedule',
    custom: 'General Services Administration',
    number: '47QSWA23D002K',
    date: '01/20/2023 - 01/19/2028',
    max: '',
  },
  {
    title: 'Mid-Range Unmanned Aircraft System',
    custom: 'U.S. Department of State',
    number: '19AQMM23D0091',
    date: '08/01/2023 - 7/31/2028',
    max: '$30,000,000',
  },
];

const subcontracts = [
  {
    title: 'Africa Peacekeeping Program (AFRICAP) III',
    custom: 'Bureau of African Affairs',
    number: 'SAQMMA17D00XX',
    date: '05/02/2017 - 05/17/2022',
    max: '$1,500,000,000.00',
  },
  {
    title: 'Cooperative Threat Reduction Integrating Contract (CTRIC) III',
    custom: 'Defense Threat Reduction Agency',
    number: 'HDTRA118D00XX',
    date: '06/04/2018 - 06/02/2023',
    max: '$970,000,000.00',
  },
  {
    title: 'Africa Contingency Operations and Training Assistance (ACOTA) II',
    custom: 'Bureau of African Affairs',
    number: '19AQMM18D00XX',
    date: '04/11/2018 - 04/10/2023',
    max: '$600,000,000.00',
  },
  {
    title:
      'International Criminal Investigative Training Assistance Program (ICITAP) Worldwide Support Services',
    custom: 'Justice Management Division',
    number: '15JPSS20D00000035',
    date: '12/31/2019 - 07/30/2027',
    max: '$400,400,000.00',
  },
  {
    title: 'Worldwide Protective Services (WPS) II',
    custom: 'Bureau of Diplomatic Security',
    number: 'SAQMMA16D00XX',
    date: '02/11/2016 - 02/20/2021',
    max: '$10,400,000,000.00',
  },
  {
    title:
      'Counter Narcotics & Global Threats (CN&GT) Operations and Logistics',
    custom: 'Air Combat Command',
    number: 'FA489016D00XX',
    date: '01/26/2016 - 01/26/2023',
    max: '$975,000,000.00',
  },
  {
    title: 'Logistics Civil Augmentation Program V (LOGCAP V)',
    custom: 'Army Material Command',
    number: 'W52P1J19D0047',
    date: '04/11/2019 - 03/01/2030',
    max: '',
  },
  {
    title: 'Regional Multi-domain Awareness Capability (RMAC)',
    custom: 'Naval Air Systems Command (NAVAIR)',
    number: 'N0042119D0023',
    date: '12/21/2018 - 12/21/2024',
    max: '',
  },
  {
    title: 'Global Advisory and Support Services',
    custom: 'Department of State',
    number: '19AQMM19D',
    date: '09/29/2019 - Present',
    max: '',
  },
  {
    title: 'Global Anti-Terrorism Assistance II Training Services (GATA II)',
    custom: 'Bureau of Diplomatic Security (DOS)',
    number: '19AQMM22P',
    date: '09/25/2019 - Present',
    max: '',
  },
];

const contracts_container = document.querySelector(
  '.contractvehicles__contracts__group',
);

const subcontracts_container = document.querySelector(
  '.contractvehicles__subcontracts__group',
);

contracts.forEach(contract => {
  const aside = document.createElement('aside');
  aside.className = 'card';

  const title = document.createElement('h5');
  title.className = 'card__title';
  title.textContent = contract.title;
  aside.appendChild(title);

  const ul = document.createElement('ul');

  const liCustomer = document.createElement('li');
  liCustomer.innerHTML = `<span>Customer:</span> ${contract.custom}`;
  ul.appendChild(liCustomer);

  const liNumber = document.createElement('li');
  liNumber.innerHTML = `<span>Contract Number:</span> ${contract.number}`;
  ul.appendChild(liNumber);

  const liDate = document.createElement('li');
  liDate.innerHTML = `<span>Date:</span> ${contract.date}`;
  ul.appendChild(liDate);

  if (contract.max) {
    const liMax = document.createElement('li');
    liMax.innerHTML = `<span>Maximum Value:</span> ${contract.max}`;
    ul.appendChild(liMax);
  }

  aside.appendChild(ul);
  contracts_container.appendChild(aside);
});

subcontracts.forEach(contract => {
  const aside = document.createElement('aside');
  aside.className = 'card';

  const title = document.createElement('h5');
  title.className = 'card__title';
  title.textContent = contract.title;
  aside.appendChild(title);

  const ul = document.createElement('ul');

  const liCustomer = document.createElement('li');
  liCustomer.innerHTML = `<span>Customer:</span> ${contract.custom}`;
  ul.appendChild(liCustomer);

  const liNumber = document.createElement('li');
  liNumber.innerHTML = `<span>Contract Number:</span> ${contract.number}`;
  ul.appendChild(liNumber);

  const liDate = document.createElement('li');
  liDate.innerHTML = `<span>Date:</span> ${contract.date}`;
  ul.appendChild(liDate);

  if (contract.max) {
    const liMax = document.createElement('li');
    liMax.innerHTML = `<span>Maximum Value:</span> ${contract.max}`;
    ul.appendChild(liMax);
  }

  aside.appendChild(ul);
  subcontracts_container.appendChild(aside);
});
